<template>
    <div>
        <overlay-pop :btn-variant="btnVariant"
                     :btn-icon="btnIcon"
                     :title="title ? title : this.id"
                     :click-trigger="clickTrigger"
                     @shown="whenPopoverShown">
            <mini-table ref="miniTable"
                        read-only
                        :entity-name="fieldFromModel ? entityName : undefined"
                        :custom-vuex-name="fieldFromModel ? customVuexName : undefined"
                        :need-model-fields="fieldFromModel"
                        :items="rows"
                        :fields="fields"
                        :enable-origin-field="!fieldFromModel && !fields"
                        disable-first-index-column
                        :enable-table-tree="tableConfig.enable"
                        :tree-id-name="tableConfig.treeIdName"
                        :tree-level-name="tableConfig.treeLevelName"
                        :tree-parent-id-name="tableConfig.treeParentIdName"
                        :expend-all="tableConfig.expendAll">
            </mini-table>
        </overlay-pop>
    </div>
</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonApiMixin from "@/mixin/em/common/api";
import OverlayPop from "@/components/workflow/stuffs/OverlayPop.vue";

export default {
    name: "OverlayMiniTable",
    components: {OverlayPop, MiniTable},
    mixins: [emCommonApiMixin],
    props: {
        btnVariant: String,
        btnIcon: String,
        entityName: String,
        customVuexName: String,
        id: [Number, String],
        queryApi: String,
        data: Object,
        title: String,
        fields: Array,
        tableConfig: {
            type: Object,
            default: () => {
                return {};
            }
        },
        lazyLoad: {
            type: Boolean,
            default: false
        },
        clickTrigger: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localUrl() {
            return this.queryApi ? this.queryApi : `${this.$_emApiMixin_entityBaseApi(this.entityName)}/findByFilter`;
        },
        localData() {
            return this.data ? this.data : {
                idFilter: this.id
            }
        },
        fieldFromModel() {
            return this.fields === undefined && this.entityName !== undefined;
        },
    },
    data() {
        return {
            rows: [],
            popoverShown: false
        }
    },
    watch: {
        id() {
            this.ifLazyGetRemote();
        },
        queryApi() {
            this.ifLazyGetRemote();
        },
    },
    mounted() {
        this.ifLazyGetRemote();
    },
    methods: {
        getRemote() {
            if (this.id || this.data) {
                if (this.lazyLoad) {
                    this.$refs.miniTable.changeLoading(true);
                }
                this.$store.dispatch('api/post', {
                    url: this.localUrl,
                    data: this.localData
                }).then(response => {
                    console.log(response);
                    let tempList = this.queryApi ? response.data : response.data.list;
                    if (this.tableConfig.highLightRow !== undefined) {
                        for (let row of tempList) {
                            let v = this.tableConfig.highLightRow(row);
                            if (v) {
                                row._rowVariant = v;
                            }
                        }
                    }
                    this.rows = tempList;
                }).finally(() => {
                    if (this.lazyLoad) {
                        this.$refs.miniTable.changeLoading(false);
                    }
                });
            }
        },
        ifLazyGetRemote() {
            if (this.lazyLoad && !this.popoverShown) {
                return;
            }
            this.getRemote();
        },
        whenPopoverShown() {
            if (!this.popoverShown) {
                this.popoverShown = true;
            }
            if (this.lazyLoad && this.rows.length === 0) {
                this.getRemote();
            }
        },
    }
}
</script>

<style scoped>

</style>
